<template>
  <v-row no-gutters>
    <v-col cols="9" class="_pr-">
      <ColorPickerV2 title="Cor padrão do ingresso" :colorSelected="selectedSection" type="item-background-color" /> 
    </v-col>

    <v-col cols="12">
      <div class="_subtitleFormFont py-6">Opções de ingresso:</div>
    </v-col>

    <v-col cols="12">
      <draggable ghost-class="ghost" :list="selectedSection.items" @start="isDragging = true" @end="isDragging = false">
        <transition-group type="transition" name="list-complete">      
          <div v-for="(opt, index) in selectedSection.items" :key="index" class="show-cursor bgHover" no-gutters>
            <Expansion 
              v-model="opt.visible" 
              :verticalExpansion="false" 
              @click="onOpen(index, opt.visible)"
            >
              <template slot="default">
                <section class="d-flex flex-column mb-2">
                  <div class="styles-item">
                    <expanded-icon :isExpanded="opt.visible"/>
                    <span :style="`font-weight: ${opt.visible ? '700' : '400'}`">Ingresso {{index + 1}}</span>
                    <div class="d-flex flex justify-end">
                      <DeleteButton @click="handleDelete(selectedSection.items, index)"/>       
                    </div>
                  </div>   
                </section>         
              </template>

              <template slot="expanded">
                <v-row no-gutters class="px-2 pb-6">
                  <v-col cols="8" class="_pr-">
                    <TextField label="Título" v-model="opt.title"/>
                  </v-col>
                  <v-col cols="4" class="_pl-">
                    <TextField 
                      v-currency="currencyOptions"
                      prefix="R$"
                      label="Valor" 
                      v-model="opt.price"
                    />
                  </v-col>

                  <v-col cols="9" class="pt-4 _pr-">
                    <ColorPickerV2 title="Cor ingresso" :colorSelected="opt" type="backgroundColor"/> 
                  </v-col>

                  <v-col cols="12" class="_pt">
                    <TextArea v-model="opt.description" height="120px" placeholder="Descrição do ingresso" :hideDetails="true"/>
                  </v-col>

                  <v-col cols="6" class="pt-4 _pr-">
                    <ColorPickerV2 title="Cor fundo botão" :colorSelected="opt" type="buttonColor"/> 
                  </v-col>
                  <v-col cols="6" class="pt-4 _pl-">
                    <ColorPickerV2 title="Cor texto botão" :colorSelected="opt" type="buttonTextColor"/> 
                  </v-col>  

                  <v-col cols="6" class="_pt _pr-">
                    <TextField label="Texto botão" v-model="opt.buttonText"/>
                  </v-col>
                  <v-col cols="6" class="_pt _pl-">
                    <TextField 
                      label="Link externo" 
                      v-model="opt.link"         
                      :hideDetails="false"
                      :rules="[rules.isValidHttps]"
                    />
                  </v-col>
                </v-row>
              </template>
            </Expansion>

          </div>
        </transition-group>
      </draggable>
    </v-col>

    <v-col cols="12" class="d-flex flex-column _btn py-2">
      <Button 
        label="Adicionar opção" 
        color="bt_gray_bg"
        textColor="darkBlue"
        textSize="0.80rem"
        icon="fa-solid fa-link"
        @click="handleAdd"
      />      
    </v-col>
  </v-row>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input"
import draggable from 'vuedraggable'
import { TICKETS_ITEM_OPTION } from '../../../../../schemas/sections'
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'
import TextArea from '../../../../_v2/ui/TextArea.vue'
import TextField from '../../../../_v2/ui/TextField.vue'
import DeleteButton from '../../../../_v2/ui/DeleteButton.vue'
import Button from '../../../../_v2/ui/Button.vue'
import Expansion from '../../../../_v2/ui/Expansion.vue'
import ExpandedIcon from '../../../../_v2/utils/ExpandedIcon.vue'

export default {
  name: 'Layout4',
  directives: { currency: CurrencyDirective },  
  components: {ColorPickerV2, TextArea, TextField, DeleteButton, Expansion, ExpandedIcon, draggable, Button},
  props: {
    selectedSection: {type: Object, required: true}
  },

  data: () => ({
    currencyOptions: {
      currency: null,
      autoDecimalMode: true,
    }, 
    rules: {
      isValidHttps: (v) => {
        const urlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w]{2,}(:\d+)?(\/[^\s]*)?$/i
        return urlRegex.test(v) || "Url inválida"
      } 
    },
    isDragging: false
  }),

  methods: {
    handleDelete(options, index) {
      options.splice(index, 1)
    },

    onOpen(index, state) {
      if (state && this.selectedSection.items && this.selectedSection.items.length > 0) {
        this.selectedSection.items.forEach((option, i) => {
          if (i !== index) option.visible = false
        })
      }
    },

    handleAdd() {
      const newTicket = TICKETS_ITEM_OPTION()
      this.selectedSection.items.push(newTicket)    
    }    
  }  
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    cursor: move !important
  }

  .styles-item {
    display: flex;
    gap: 10px;
    height: 50px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding: 0 8px 0 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    cursor: pointer;
    animation: changeCursor 3s forwards;
  }

  .show-cursor {
    cursor: move !important;
    transition: all 0.3s;    
  }

  .show-cursor:hover {
    border-radius: 4px;
  }

  .bgHover:hover {
    background-color: #FAFBFB;    
  }

  @keyframes changeCursor {
    100% {
      cursor: move;
    }
  }

  .list-complete-item {
    transition: all 0.8s;
    display: inline-block;
    margin-right: 10px;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .list-complete-leave-active {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
  }    
</style>